<app-confirm-delete-product-part [(display)]="confirmDeleteOn"
                                 (done)="onDeleteConfirmation($event)"></app-confirm-delete-product-part>

<div *ngIf="prodParts as ppData else pploading" style="overflow:visible">
  <p-toolbar styleClass="">
    <ng-template pTemplate="left">
    </ng-template>

    <ng-template pTemplate="right">
      <p-button label="Запросить" icon="pi pi-question" styleClass="mr-2" (onClick)="onAskEditing()"
                pTooltip="Запросить разрешение на редактирование" tooltipPosition="top"></p-button>

      <p-button label="Разрешить" icon="pi pi-pen-to-square" styleClass="p-button-success mr-2" [disabled]="!allowEditing"
                pTooltip="Разрешить редактирование" tooltipPosition="top"></p-button>

      <p-button icon="pi pi-refresh" label="Обновить" styleClass="p-button-success mr-2" [disabled]="editing" (onClick)="reloadTable($event)"
                pTooltip="Обновить состав" tooltipPosition="top"></p-button>

      <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportData()"
                pTooltip="Экспортировать состав" tooltipPosition="top" [disabled]="editing"></p-button>
    </ng-template>
  </p-toolbar>

  <p-table #prodPartsTable [value]="ppData"
           selectionMode="single"
           [(selection)]="selectedProdPart"
           dataKey="PPID"
           editMode="row"
           [loading]="loading"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
           (onRowSelect)="onRowSelect($event)"
           (onRowUnselect)="onRowUnselect($event)"
           [rowHover]="true"
           sortField="PARTNOTE"
           [resizableColumns]="true">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 7rem"></th>
        <th pSortableColumn="PARTNOTE" pResizableColumn width="15%" class="do-not-overlay-text">Назначение <p-sortIcon field="PARTNOTE"></p-sortIcon></th>
        <th pSortableColumn="QUANTITY" pResizableColumn width="6%" class="do-not-overlay-text">Количество <p-sortIcon field="QUANTITY"></p-sortIcon></th>
        <th pSortableColumn="PARTCODE" pResizableColumn class="do-not-overlay-text">Код части <p-sortIcon field="PARTCODE"></p-sortIcon></th>
        <th pSortableColumn="PARTNAME" pResizableColumn width="25%" *ngIf="!editMode" class="do-not-overlay-text">Описание <p-sortIcon field="PARTNAME"></p-sortIcon></th>
        <th pSortableColumn="PARTPRICE" pResizableColumn width="6%" class="do-not-overlay-text">Цена <p-sortIcon field="PARTPRICE"></p-sortIcon></th>
        <th pSortableColumn="PARTSTOCK" pResizableColumn width="6%" class="do-not-overlay-text">Склад <p-sortIcon field="PARTSTOCK"></p-sortIcon></th>
        <th pSortableColumn="PARTSOLD" pResizableColumn width="6%" class="do-not-overlay-text">Продано <p-sortIcon field="PARTSOLD"></p-sortIcon></th>
        <th pSortableColumn="PARTRESERVE" pResizableColumn width="6%" class="do-not-overlay-text">Резерв <p-sortIcon field="PARTRESERVE"></p-sortIcon></th>
        <th style="width: 3rem"></th>
      </tr>
      <tr>
        <th style="width: 7rem"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['PARTNOTE']" (input)="prodPartsTable.filter($event.target.value, 'PARTNOTE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['QUANTITY']" (input)="prodPartsTable.filter($event.target.value, 'QUANTITY', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['PARTCODE']" (input)="prodPartsTable.filter($event.target.value, 'PARTCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th *ngIf="!editMode"><input pInputText type="text" [(ngModel)]="cf3['PARTNAME']" (input)="prodPartsTable.filter($event.target.value, 'PARTNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['PARTPRICE']" (input)="prodPartsTable.filter($event.target.value, 'PARTPRICE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['PARTSTOCK']" (input)="prodPartsTable.filter($event.target.value, 'PARTSTOCK', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['PARTSOLD']" (input)="prodPartsTable.filter($event.target.value, 'PARTSOLD', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="cf3['PARTRESERVE']" (input)="prodPartsTable.filter($event.target.value, 'PARTRESERVE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th style="width: 3rem"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-prodparts let-editing="editing" let-ri="rowIndex">
      <tr [pSelectableRow]="prodparts" [pEditableRow]="prodparts">

        <!--<td style="text-align:center">-->
        <td>
          <button *ngIf="!editing && !editMode && allowEditing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onPpRowEditInit(prodparts)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="editing" [disabled]="!allowSave(prodparts)" pButton pRipple type="button" pSaveEditableRow icon="pi pi-save" (click)="onPpRowEditSave(prodparts)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onPpRowEditCancel(prodparts, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="prodparts.PARTNOTE" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="col" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prodparts.PARTNOTE | pipetrimstr }}</div></ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="number" [(ngModel)]="prodparts.QUANTITY" [style]="{'width':'100%'}" step="1" style="text-align: right" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output">
              <div class="col" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{prodparts.QUANTITY | number:'1.0-2' }}</div>
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="overflow: visible !important; ">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <app-productselector [showLabel]="false" [allowComplex]="allowComplex" [allowOld]="allowOld"
                                   [searchText]="prodparts.PARTCODE"
                                   class="align-self-baseline"
                                   (selectedProduct)="onProductPartSelection($event, prodparts)">
              </app-productselector>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                <a [routerLink]="['/edit-product', prodparts.PARTID]">{{prodparts.PARTCODE | pipetrimstr }}</a>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="!editMode" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prodparts.PARTNAME | pipetrimstr }}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{prodparts.PARTPRICE | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{prodparts.PARTSTOCK | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{prodparts.PARTSOLD | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{prodparts.PARTRESERVE | number:'1.0-2' }}</td>
        <td style="width: 3rem">
          <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-success p-button-text"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer">
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td style="overflow: visible !important; "></td>
        <td *ngIf="!editMode" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"><!--{{prodparts.PARTNAME | pipetrimstr }}--></td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalIncomeCost | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right"></td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right"></td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right"><!----></td>
        <td style="width: 3rem"></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="grid">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить часть в товар" icon="pi pi-plus" (onClick)="onAddProdPart($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="editMode || !allowEditing"
                      pTooltip="Добавить новую строку" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Удалить часть" icon="pi pi-minus" (onClick)="onRemoveProdPart($event)" styleClass="ml-2 mt-2 mr-2 p-button-warning " [disabled]="editMode || noPpRowSelected || !allowEditing"
                      pTooltip="Убрать выбранную часть товара" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9">Нет составных частей</td>
      </tr>
    </ng-template>
    <!--<ng-template pTemplate="summary">
      Footer
    </ng-template>-->
  </p-table>
</div>

<ng-template #pploading>
  <p>Состав изделия загружается...</p>
</ng-template>

